<template>
  <div id="uploadnews">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="News type" prop="type">
        <el-select v-model="ruleForm.type" placeholder="Please select the type of news">
          <el-option v-for="t in newsTypes" :key="t.id" :label="t.id + '.' + t.name" :value="String(t.id)"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="News Title" prop="title">
        <el-input type="textarea" v-model="ruleForm.title"></el-input>
      </el-form-item>

      <CreateNewsEditor></CreateNewsEditor>


      <!-- <el-form-item label="新闻内容" prop="content" >
          <el-input type="textarea" v-model="ruleForm.content" :disabled="true"></el-input>
      </el-form-item> -->

      <el-form-item prop="author">
        <label slot="label">Author</label>
        <el-input v-model="ruleForm.author" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="image link" prop="pic">
        <el-input v-model="ruleForm.pic" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="Lock in news" prop="locked">
        <el-switch v-model="ruleForm.locked"
          :active-value="1"
          :inactive-value="0"
          ></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">Create Now</el-button>
        <el-button @click="resetForm('ruleForm')">Reset</el-button>
      </el-form-item>
    </el-form>
  </div>


</template>

<script>
import CreateNewsEditor from './CreateNewsEditor.vue';
import { NEWS_TYPES } from '@/constants/newsTypes';
import { request } from '@/api/http';

export default {
  components: {
    CreateNewsEditor,
  },
  data () {
    return {
      newsTypes: NEWS_TYPES,
      ruleForm: {
        type: '',
        title: '',
        author: sessionStorage.getItem('loginin') || '',
        pic: '',
        locked: 1, // 新增的新闻默认锁定
      },
      rules: {
        type: [
          { required: true, message: 'Please select the type of news', trigger: 'change' }
        ],
        title: [
          { required: true, message: 'Please fill in the news title', trigger: 'blur' },
          { max: 200, message: 'Less than 200 characters in length', trigger: 'blur' }
        ],
        author: [
          {  },
        ],

      },
    };
  },

  computed: {
    //为了监听msg1数据的变化
    listenstore(){
      return this.$store.state.msg1;
    }
  },

  watch: {
    listenstore:function(){
      //取正文第一张图片作为缩略图
      const html = this.$store.state.msg1 || '';
      const picPath = (html.split('<img src="')[1] || '').split('" title="')[0];
      this.ruleForm.pic = picPath;
    },

  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          // 校验不通过：明确提示用户缺了什么（原来静默返回导致"点了没反应"）
          const hasType = this.ruleForm.type !== '' && this.ruleForm.type !== undefined;
          const hasTitle = this.ruleForm.title.trim() !== '';
          if (!hasType && !hasTitle) {
            this.$message.warning('请先选择新闻类型并填写标题');
          } else if (!hasType) {
            this.$message.warning('请先选择新闻类型');
          } else if (!hasTitle) {
            this.$message.warning('请填写新闻标题');
          } else {
            this.$message.warning('请检查表单必填项（标题不能超过200字）');
          }
          return false;
        }
        request('/CalawaEnServlet/NewsServlet', {
          action: 'addNews',
          type: this.ruleForm.type,
          title: this.ruleForm.title,
          content: (this.$store.state.msg1 || '').split('../../../public_html').join(''),
          pic: this.ruleForm.pic,
          author: this.ruleForm.author,
          locked: this.ruleForm.locked,
          username: sessionStorage.getItem('loginin') || '',
          isAdmin: sessionStorage.getItem('isAdmin') === '1' ? 1 : 0,
        }, 'post').then(()=> {
          this.$router.push({ name: 'listnews', params: { type: 0, page: 1 }});
        }).catch(error=> {
          console.log(error);
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
}
</script>

<style lang="scss" scoped>
#uploadnews{
  width:1083px;
  margin: 0 auto;

  .el-form{
    width: 460px;

    text-align: left;

    // margin-top: 30px;

    div:nth-child(3){
      width: 1083px;

      margin: 20px 0 30px 0;
    }
  }
}
</style>